import { defineMessages } from 'react-intl';

export default defineMessages({
    paDriverRightRailTitle: {
        id: 'quoteandbind.pa.views.pa-driver-details.Your Drivers',
        defaultMessage: 'Your Drivers',
    },
    paDriverMainSectionHeader: {
        id: 'ml.quoteandbind.pa.views.pa-driver-details.MainSectionHeader',
        defaultMessage: 'DRIVER {index} OF {length}',
    },
    wellReviewYourAdditionalDriversNext: {
        id: 'quoteandbind.pa.views.pa-driver-details.We\'ll review your additional drivers next',
        defaultMessage: 'We\'ll review your {additionalDrivers} next'
    },
    wellWorkOnYourAdditionalDriversNext: {
        id: 'quoteandbind.pa.views.pa-driver-details.We\'ll work on your additional drivers next',
        defaultMessage: 'We\'ll work on your {additionalDrivers} next'
    },
    wellReviewYourVehiclesNext: {
        id: 'quoteandbind.pa.views.pa-driver-details.We\'ll review your vehicles next',
        defaultMessage: 'We\'ll review your {vehicles} next'
    },
    wellWorkOnYourVehiclesNext: {
        id: 'quoteandbind.pa.views.pa-driver-details.We\'ll work on your vehicles next',
        defaultMessage: 'We\'ll work on your {vehicles} next'
    },
    licenseMatchingMsg: {
        id: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.LicenceMatchMsg',
        defaultMessage: 'Sorry, but this driver\'s license number matches that of {driver}. Please ensure that all licence numbers are unique.'
    },
    licenseNumberNotUnique: {
        id: 'quoteandbind.pa.controllers.PADriverDetailsCtrl.Licence number is not unique',
        defaultMessage: 'Licence number is not unique'
    },
    additionalDrivers: {
        id: 'ml.quoteandbind.pa.views.pa-driver-details.additional drivers',
        defaultMessage: 'additional drivers'
    },
    vehicles: {
        id: 'ml.quoteandbind.pa.views.pa-driver-details.vehicles',
        defaultMessage: 'vehicles'
    },
    additionalAtFaultAccidents: {
        id: 'quoteandbind.pa.views.pa-driver-details.If you have had any additional at fault accidents',
        defaultMessage: 'If you have had any additional at fault accidents, not at fault accidents, losses or violations in the past 5 years, please add them here.'
    },
    dateOfEvent: {
        id: 'quoteandbind.pa.views.pa-driver-details.Date of Event',
        defaultMessage: 'Date of Event'
    },
    pleaseSpecifyType: {
        id: 'quoteandbind.pa.views.pa-driver-details.Please specify the type',
        defaultMessage: 'Please specify the type, date of the event and amount paid'
    },
    showDisclosureButtonText: {
        id: 'quoteandbind.pa.views.pa-driver-details.Add Incident',
        defaultMessage: 'Add Incident'
    },
    showPrefilledDisclosureDescription: {
        id: 'quoteandbind.pa.views.pa-driver-details.We found this information regarding accidents',
        defaultMessage: 'We found this information regarding accidents and other claims for this driver or household.'
    },
    showManualDisclosureDescription: {
        id: 'quoteandbind.pa.views.pa-driver-details.You entered this information regarding accidents',
        defaultMessage: 'You entered this information regarding accidents and other claims for this driver or household.'
    },
    date: {
        id: 'quoteandbind.pa.views.pa-driver-details.Date',
        defaultMessage: 'Date'
    },
    driver: {
        id: 'quoteandbind.pa.views.pa-driver-details.Driver',
        defaultMessage: 'Driver'
    },
    category: {
        id: 'quoteandbind.pa.views.pa-driver-details.Category',
        defaultMessage: 'Category'
    },
    descripion: {
        id: 'quoteandbind.pa.views.pa-driver-details.Description',
        defaultMessage: 'Description'
    },
    amountPaid: {
        id: 'quoteandbind.pa.views.pa-driver-details.Amount Paid',
        defaultMessage: 'Amount Paid'
    },
    actions: {
        id: 'quoteandbind.pa.views.pa-driver-details.Actions',
        defaultMessage: 'Actions'
    },
    delete: {
        id: 'quoteandbind.pa.views.pa-driver-details.Delete',
        defaultMessage: 'Delete'
    },
    dateMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Date Mobile',
        defaultMessage: 'Date:'
    },
    driverMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Driver Mobile',
        defaultMessage: 'Driver:'
    },
    categoryMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Category Mobile',
        defaultMessage: 'Category:'
    },
    typeMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Type Mobile',
        defaultMessage: 'Type:'
    },
    descripionMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Description Mobile',
        defaultMessage: 'Description:'
    },
    amountPaidMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Amount Paid Mobile',
        defaultMessage: 'Amount Paid:'
    },
    actionsMobile: {
        id: 'quoteandbind.pa.views.pa-driver-details.Actions Mobile',
        defaultMessage: 'Actions:'
    },
    hvqDriversHeader: {
        id: 'ml.quoteandbind.pa.views.pa-driver-details.hvq.Review the identified fields for your drivers',
        defaultMessage: 'Review the identified fields for your drivers'
    },
    hvqDriversSubHeader: {
        id: 'ml.quoteandbind.pa.views.pa-driver-details.hvq.Verify the information we prefilled for you',
        defaultMessage: 'Verify the information we prefilled for you'
    },
    showDisclosureTooltipLabel: {
        id: 'quoteandbind.pa.views.pa-driver-details.What if one of the items shown is not mine?',
        defaultMessage: 'What if one of the items shown is not mine?'
    },
    showDisclosureTooltipContent: {
        id: 'quoteandbind.pa.views.pa-driver-details.If one of the items shown is not for you',
        defaultMessage: 'If one of the items shown is not for you or your household, please contact us by chat. We will advise you on the proof needed to remove the item.'
    },
    showDuplicateLicenseError: {
        id: 'quoteandbind.pa.views.pa-driver-details.License numbers must be unique.',
        defaultMessage: 'License numbers must be unique.'
    },
    noSpouseAddedtoPNI: {
        id: 'quoteandbind.pa.views.pa-driver-details.noSpouseAddedtoPNI',
        defaultMessage: 'Please enter spouse details to proceed.'
    },
    singlePNICannotHaveSpouse: {
        id: 'quoteandbind.pa.views.pa-driver-details.singlePNICannotHaveSpouse',
        defaultMessage: 'There must be another household member or rated driver listed as spouse.'
    },
    weatherLossYes: {
        id: 'quoteandbind.pa.views.pa-driver-details.Yes',
        defaultMessage: 'Y'
    },
    weatherLossNo: {
        id: 'quoteandbind.pa.views.pa-driver-details.No',
        defaultMessage: 'N'
    },
     checkUniqueSpouseMessageQB: {
        id: 'quoteandbind.pa.views.pa-driver-details.Spouse has already been selected as a relationship to insured on another driver.',
        defaultMessage: 'Spouse has already been selected as a relationship to insured on another driver.'
    },
     checkNoSpouseQB: {
        id: 'quoteandbind.pa.views.pa-driver-details.Please enter the spouse details to proceed with the quote',
        defaultMessage: 'Please enter the spouse details to proceed with the quote.'
    },
});
